var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", [
      _c("div", [
        _c("h3", [
          _vm._v("\n        Generate Character Model and Animations\n      ")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Clicking the following button will generate character models and store them in Google Storage."
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          { on: { click: _vm.generateCharacterModelAndAnimations } },
          [_vm._v("Generate Character Model and Animations")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h1", [
        _vm._v(
          "Welcome to the Admin page where you are granted powers and declared a iBegician!"
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54c38a05", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c38a05","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin.vue
// module id = null
// module chunks = 